<template>
  <div class="specialProcess-tab-info">
    <el-row style="border-bottom: 1px solid #ccc;">
      <el-col :span="8">
        <base-string :read-only="true" v-model="info.materialCode" label="款号"></base-string>
      </el-col>
      <el-col :span="8">
        <base-string :read-only="true" v-model="info.materialDesc" label="款名"></base-string>
      </el-col>
      <el-col :span="8">
        <base-select
          :read-only="true"
          v-model="info.brandCode"
          label="品牌"
          apiName="POST_SPS_SYS_ENUM_URL"
          :params="{typeCode: 'Brand'}"
          placeholder="品牌"
        ></base-select>
      </el-col>
      <el-col :span="8">
        <base-date-picker
          v-model="info.years"
          :read-only="true"
          type="year"
          format="yyyy"
          valueFormat="{y}"
          label="年份"
          placeholder="年份"
        ></base-date-picker>
      </el-col>
      <el-col :span="8">
        <base-string :read-only="true" v-model="info.followOrderUserName" label="设计跟单"></base-string>
      </el-col>
      <el-col :span="8">
        <base-date-picker
          v-model="info.updatedTime"
          :read-only="true"
          label="更新日期"
          placeholder="更新日期"
        ></base-date-picker>
      </el-col>
      <el-col :span="8">
        <base-string
          v-model="info.patternDesigner"
          :read-only="readOnly"
          label="纸样师"
          placeholder="纸样师"
        ></base-string>
      </el-col>
      <el-col :span="8">
        <base-string
          v-model="info.sizeGrad"
          :read-only="readOnly"
          label="放码师"
          placeholder="放码师"
        ></base-string>
      </el-col>
      <el-col :span="8">
        <base-string
          v-model="info.craftsman"
          :read-only="readOnly"
          label="工艺师"
          placeholder="工艺师"
        ></base-string>
      </el-col>
      <el-col :span="8">
        <base-string
          v-model="info.checkByName"
          :read-only="true"
          label="审核人"
          placeholder="审核人"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string :read-only="readOnly" v-model="info.remark" label="备注"></base-string>
      </el-col>
    </el-row>
    <base-title title="前后款式图"></base-title>
    <el-row class="tab-info__contain">
      <el-col :span="12">
        <img :src="info.frontBackImg | parseImgUrlToken" alt style="width: 100%;" />
      </el-col>
      <el-col :span="2" :offset="1" v-if="!readOnly">
        <upload-file :autoUpload="false" v-model="info.frontBackImg" btn-text :allowUploadType="['jpg', 'jpeg', 'png']" :uploadData="uploadData">
          <el-button type="primary">点击上传</el-button>
        </upload-file>
      </el-col>
    </el-row>
    <template v-if="info.woolenFlag === 0">
      <base-title title="纸样裁片数" class="tab-info__item-line"></base-title>
      <el-row class="tab-info__contain">
        <el-button type="primary" :disabled="readOnly" @click="handleAddPieceList">新增</el-button>
      </el-row>
      <el-table :data="info.pieceList" style="margin-top: 10px" stripe>
        <el-table-column
          :show-overflow-tooltip="true"
          property="pieceName"
          label="裁片名称"
          :min-width="100"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.pieceName" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="pieceNum"
          label="裁片数量"
          :min-width="100"
        >
          <template slot-scope="scope">
            <base-string :read-only="readOnly" v-model="scope.row.pieceNum" label></base-string>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="materialDescCn"
          label="操作"
          :min-width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              :disabled="readOnly"
              @click="handleDeletePieceList(scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <base-title title="面料详情" class="tab-info__item-line"></base-title>
    <el-row class="tab-info__contain">
      <el-button type="primary" :disabled="readOnly" @click="handleAddFabrich">新增</el-button>
      <el-button type="primary" :disabled="readOnly" @click="handleRefreshFabrich">刷新</el-button>
    </el-row>
    <el-table :data="info.fabricList" style="margin-top: 10px" stripe>
      <el-table-column
        :show-overflow-tooltip="true"
        property="fabricName"
        label="面料名称"
        :min-width="100"
      >
        <template slot-scope="scope">
          <base-string :read-only="readOnly" v-model="scope.row.fabricName" label></base-string>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" property="spec" label="纱支规格" :min-width="100">
        <template slot-scope="scope">
          <base-string :read-only="readOnly" v-model="scope.row.spec" label></base-string>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        property="component"
        label="成分"
        :min-width="100"
      >
        <template slot-scope="scope">
          <base-string :read-only="readOnly" v-model="scope.row.component" label></base-string>
        </template>
      </el-table-column>
      <el-table-column
        v-if="info.woolenFlag === 0"
        :show-overflow-tooltip="true"
        property="breadth"
        label="幅宽/M"
        :min-width="100"
      >
        <template slot-scope="scope">
          <base-string :read-only="readOnly" v-model="scope.row.breadth" label></base-string>
        </template>
      </el-table-column>
      <el-table-column
        v-if="info.woolenFlag === 1"
        :show-overflow-tooltip="true"
        property="needles"
        label="针数"
        :min-width="100"
      >
        <template slot-scope="scope">
          <base-string :read-only="readOnly" v-model="scope.row.needles" label></base-string>
        </template>
      </el-table-column>
      <el-table-column
        v-if="info.woolenFlag === 1"
        :show-overflow-tooltip="true"
        property="weight"
        label="克重/g"
        :min-width="100"
      >
        <template slot-scope="scope">
          <base-string :read-only="readOnly" v-model="scope.row.weight" label></base-string>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        property="singleDosage"
        label="单件用量(M)"
        :min-width="100"
      >
        <template slot-scope="scope">
          <base-string :read-only="readOnly" v-model="scope.row.singleDosage" label></base-string>
        </template>
      </el-table-column>

      <el-table-column
        :show-overflow-tooltip="true"
        property="materialDescCn"
        label="操作"
        :min-width="100"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            :disabled="readOnly"
            @click="handleDeleteFabrich(scope.$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <base-title title="版型及缝制修改要求" class="tab-info__item-line"></base-title>
    <el-row>
      <el-col :span="24">
        <base-string
          :rows="rows"
          :read-only="readOnly"
          v-model="info.confirmSamplePattern"
          type="textarea"
          label="确认样衣版型及工艺修改"
          :label-width="labelConfig.width"
          :text-align="labelConfig.align"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :rows="rows"
          :read-only="readOnly"
          v-model="info.suggestion"
          type="textarea"
          :label-width="200"
          :text-align="labelConfig.align"
          :labelPaddingRight="4"
          label="样衣面辅料及整体搭配效果确定"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :rows="rows"
          :read-only="readOnly"
          v-model="info.riskAssessment"
          type="textarea"
          :label-width="labelConfig.width"
          :text-align="labelConfig.align"
          label="风险评估"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :rows="rows"
          :read-only="readOnly"
          v-model="info.qcAdvise"
          type="textarea"
          :label-width="labelConfig.width"
          :text-align="labelConfig.align"
          label="QC建议"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :rows="rows"
          :read-only="readOnly"
          v-model="info.stripCrystalLocation"
          type="textarea"
          :label-width="labelConfig.width"
          :text-align="labelConfig.align"
          label="朴条&水晶条位置"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :rows="rows"
          :read-only="readOnly"
          v-model="info.draftPosition"
          type="textarea"
          :label-width="labelConfig.width"
          :text-align="labelConfig.align"
          label="花稿位置"
          style="width: 805px;"
        ></base-string>
      </el-col>
      <el-col :span="24">
        <base-string
          :read-only="readOnly"
          :rows="rows"
          v-model="info.boardColor"
          type="textarea"
          :label-width="labelConfig.width"
          :text-align="labelConfig.align"
          label="确认板颜色"
          style="width: 805px;"
        ></base-string>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import uploadFile from "components/base-control/upload-file.vue";
import { parseImgUrlToken } from "src/filter/modules/img";
import { mixins } from "./mixins";
export default {
  name: "tab-info",
  filters: {
    parseImgUrlToken
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixins],
  components: {
    uploadFile
  },
  computed: {},
  methods: {
    handleRefreshFabrich() {
      this.$emit("handleRefreshFabrich");
    },
    handleAddFabrich() {
      this.info.fabricList.push({});
    },
    handleDeleteFabrich(index) {
      this.info.fabricList.splice(index, 1);
    },
    handleAddPieceList() {
      this.info.pieceList.push({});
    },
    handleDeletePieceList(index) {
      this.info.pieceList.splice(index, 1);
    }
  },
  mounted() {},
  data() {
    return {
      labelConfig: {
        width: 200,
        align: 'left'
      },
      list: [],
      rows: 4,
      uploadData: {
        module: 'pro-technics',
        userId: this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.adminUserName
      }
    };
  }
};
</script>

<style scoped>
.tab-info__item-line {
  margin-top: 20px;
  border-top: 1px solid #ccc;
}
.tab-info__contain {
  margin-bottom: 15px;
}
</style>
